import type { ReactNode } from 'react';

type RichTextChunk = ReactNode[];

export default {
    span: (...chunks: RichTextChunk) => <span>{chunks}</span>,
    small: (...chunks: RichTextChunk) => <small>{chunks}</small>,
    strong: (...chunks: RichTextChunk) => <strong>{chunks}</strong>,
    b: (...chunks: RichTextChunk) => <strong>{chunks}</strong>,
    em: (...chunks: RichTextChunk) => <em>{chunks}</em>,
    p: (...chunks: RichTextChunk) => <p>{chunks}</p>,
    sup: (...chunks: RichTextChunk) => <sup>{chunks}</sup>,
};
